import { Button } from "@/components/ui/button";
import { ShieldCheck, TrendingUp, FileCheck2, Building2 } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 text-white overflow-hidden bg-[#0e0e11]">
        <img src="https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Scaffolding" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative z-10 flex items-center gap-3">
          <img src="/pcm-logo.png" alt="PCM" className="h-12 w-12 object-contain bg-white rounded-md p-1" />
          <div>
            <div className="font-display font-bold text-lg leading-tight">CV Putra Cilegon Mandiri</div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-400">Finance &amp; Accounting</div>
          </div>
        </div>
        <div className="relative z-10 space-y-6">
          <h1 className="font-display text-4xl xl:text-5xl font-extrabold leading-none">
            Finance &amp; Accounting
          </h1>
          <p className="text-slate-300 max-w-md leading-relaxed">
            Kelola Purchase Order, kontrak, tarif per klien, perhitungan sewa berbasis surat jalan,
            proforma, invoice, hingga rekonsiliasi dan closing proyek dalam satu platform.
          </p>
          <div className="grid grid-cols-2 gap-4 max-w-md">
            {[["Perhitungan Akurat", TrendingUp], ["Proforma & Invoice", FileCheck2], ["Multi Klien & Proyek", Building2], ["Audit Log Lengkap", ShieldCheck]].map(([t, Icon]) => (
              <div key={t} className="flex items-center gap-2 text-sm text-slate-200">
                <Icon className="h-4 w-4 text-[#9333EA]" /> {t}
              </div>
            ))}
          </div>
        </div>
        <div className="relative z-10 text-xs text-slate-500">finance.cvpcm.org · Zona Waktu Asia/Jakarta</div>
      </div>

      {/* Right login */}
      <div className="flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-sm space-y-8">
          <div className="lg:hidden flex items-center gap-3 justify-center mb-4">
            <img src="/pcm-logo.png" alt="PCM" className="h-10 w-10 object-contain" />
            <div className="font-display font-bold">CV Putra Cilegon Mandiri</div>
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold tracking-tight">Masuk ke Akun Anda</h2>
            <p className="text-muted-foreground text-sm mt-2">Gunakan akun Google perusahaan yang sama dengan aplikasi material.</p>
          </div>
          <Button onClick={handleLogin} data-testid="google-login-btn" className="w-full h-12 text-base bg-[#9333EA] hover:bg-[#7e22ce] transition-colors">
            <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24"><path fill="#fff" d="M12 11v2.8h4a3.4 3.4 0 0 1-1.5 2.2l2.4 1.9c1.4-1.3 2.2-3.2 2.2-5.5 0-.5 0-1-.1-1.4H12z"/><path fill="#fff" d="M6.6 14.3l-.5.4-1.9 1.5A8 8 0 0 0 12 20c2.2 0 4-.7 5.3-2l-2.4-1.9c-.7.5-1.6.8-2.9.8-2.2 0-4-1.5-4.7-3.5z" opacity=".85"/><path fill="#fff" d="M4.2 7.8A8 8 0 0 0 4 12c0 1.3.3 2.5.8 3.6l2.4-1.9C7 13.2 6.9 12.6 6.9 12s.1-1.2.3-1.7L4.2 7.8z" opacity=".6"/><path fill="#fff" d="M12 6.5c1.2 0 2.3.4 3.2 1.2l2.1-2.1A8 8 0 0 0 4.9 7.8l2.9 2.3C8.5 8 10 6.5 12 6.5z" opacity=".9"/></svg>
            Lanjut dengan Google
          </Button>
          <p className="text-xs text-muted-foreground text-center leading-relaxed">
            Hak akses (Super Admin, Finance, Logistik, Viewer) diatur oleh administrator setelah login pertama.
          </p>
        </div>
      </div>
    </div>
  );
}
